import PrimaryButton from "@/Components/UI/Forms/PrimaryButton";
import { AnalyticsContext } from "@/Contexts/AnalyticsContext";
import { CookieManagerContext } from "@/Contexts/CookieManagerContext";
import { useContext } from "react";

export default function CookieBanner() {
    const cookieManager = useContext(CookieManagerContext);
    const analytics = useContext(AnalyticsContext);

    const openCookieSetting = () => {
        cookieManager.setShowCookieBanner(false);
        cookieManager.setShowCookieSettingsModal(true);
    };

    const closeCookeBannerAgreed = () => {
        cookieManager.setShowCookieBanner(false);
        cookieManager.setShowCookieSettingsModal(false);
        cookieManager.setAnalyticsToggleState(true);
        cookieManager.setAdvertisingToggleState(true);
        cookieManager.saveCookieSettingsAndCloseAll(
            {
                analytics: true,
                advertising: true,
            },
            analytics,
        );
    };

    return (
        cookieManager.showCookieBanner &&
        !route().current("privacy") &&
        !route().current("terms") && (
            <div className="fixed bottom-0 z-50 w-full text-black lg:p-6">
                <div
                    className="flex flex-col bg-white p-4 drop-shadow-top lg:flex-row lg:rounded-xl lg:p-8 lg:shadow-lg"
                    data-testid="cookie-banner"
                >
                    <p
                        data-testid="cookie-banner-text"
                        className="mb-4 text-sm lg:my-2 lg:mb-6 lg:text-lg"
                    >
                        We use cookies and similar technologies to allow our
                        site to function, deliver you coaching services,
                        personalize your experience, and understand how users
                        use our site. If you click ‘I Agree’, we may also use
                        these technologies for advertising purposes. See{" "}
                        <button
                            data-testid="cookie-settings-link"
                            className="text-brand-red underline outline-none"
                            onClick={openCookieSetting}
                        >
                            Sharing Settings
                        </button>{" "}
                        to manage your preferences or opt out. See our{" "}
                        <a
                            data-testid="cookie-privacy-link"
                            className="text-brand-red underline"
                            href={route("privacy")}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Privacy Policy
                        </a>{" "}
                        to learn more.
                    </p>
                    <div
                        data-testid="cookie-banner-container"
                        className="flex items-center justify-end gap-3 sm:flex-row lg:min-w-[500px]"
                    >
                        <PrimaryButton
                            onClick={closeCookeBannerAgreed}
                            className="order-2 grow justify-center sm:w-0 lg:py-4"
                        >
                            I Agree
                        </PrimaryButton>
                        <button
                            data-testid="cookie-settings-button"
                            className="grow text-brand-red underline sm:w-0"
                            onClick={openCookieSetting}
                        >
                            Sharing Settings
                        </button>
                    </div>
                </div>
            </div>
        )
    );
}
